import React from 'react'
import BigBox from '../../components/ad_types/BigBox'
import zonePosts from './../../components/zone_posts/zonePosts'
import SidebarHeadlines from './../../components/headlines/sidebar/SidebarHeadlines'

export default function Sidebar() {
    const Headlines = zonePosts('olympics', 'headlines')(SidebarHeadlines)

    return (
        <React.Fragment>
            <BigBox bg={false} view="all" visible={true} refresh={false} />
            <Headlines postHeader={'OLYMPICS'} />
        </React.Fragment>
    )
}
